// eslint-disable-next-line no-shadow
export enum Icons {
   plus = 'fas:faPlus',
   delete = 'fas:faTimes',
   edit = 'fas:faEdit',

   chevronDown = 'fas:faChevronDown',
   chevronUp = 'fas:faChevronUp',
}
